import request from '@/utils/request'
import https from '@/utils/https.js'
//获取学校列表
export function getSchoolListAPI(page, limit, province, name, is_syl, is_yjsy, is_zhx) {
    return request({
        url: '/web/yjs_school/list',
        method: 'post',
        data:{
          page,
          limit,
          province,
          name,
          is_syl,
          is_yjsy,
          is_zhx
        }
    })
}

//学校招生信息
export function getSchoolDetailAPI(school_id,news_type) {
    return request({
        url: '/web/yjs_school/news',
        method: 'post',
        data:{
          page:1,
          limit:100,
          school_id,
          news_type
        }
    })
}
//学校网报公告
export function getSchoolNetReportAPI(school_id) {
    return request({
        url: '/web/yjs_school/notices',
        method: 'post',
        data:{
          page:1,
          limit:100,
          school_id
        }
    })
}

//招生信息详情
export function getSchoolDetailsAPI(id) {
    return request({
        url: '/web/yjs_school/news_detail',
        method: 'post',
        data:{
          news_id:id
        }
    })
}

//学校详情
export function getSchoolDetailssAPI(school_id) {
    return request({
        url: '/web/yjs_school/detail',
        method: 'post',
        data:{
          school_id
        }
    })
}

//专业列表
export function getSchoolListsAPI(school_id) {
    return request({
        url: '/web/yjs_school/categories',
        method: 'post',
        data:{
          school_id,
          special_class:1
        }
    })
}

//专业详情
export function getSchoolMajorAPI(id,cate_name){
    return request({
        url: '/web/yjs_school/specials',
        method: 'post',
        data:{
          school_id:id,
          cate_name:cate_name,
          special_class:1
        }
    })
}

//获取学位类型选项
export function getSchoolDegreeAPI() {
    return request({
        url: '/web/yjs_school/special/degree_types',
        method: 'post'
    })
}

//专业学位类别列表
export function getSchoolDegreeTypeAPI() {
    return request({
        url: '/web/yjs_school/special/pro_categories',
        method: 'post'
    })
}

//学术学位类别列表
export function getSchoolDegreeTypeAcademicAPI() {
    return request({
        url: '/web/yjs_school/special/ml_list',
        method: 'post'
    })
}
//一级学科列表
export function getSchoolDegreeTypeFirstAPI(ml_code) {
    return request({
        url: '/web/yjs_school/special/yjxk_list',
        method: 'post',
        data:{
          ml_code
        }
    })
}

//获取专业列表分组
export function getSchoolDegreeTypeGroupAPI(school_id,keyword,xw_type,ml_code,yjxk_code,study_type,ty_type,gg_type,page,limit) {
    return request({
        url: '/web/yjs_school/special/list',
        method: 'post',
        data:{
          school_id,
          keyword,
          xw_type,
          ml_code,
          yjxk_code,
          study_type,
          ty_type,
          gg_type,
          page,
          limit
        }
    })
}
